import { useCallback, useRef } from "react"

const DEFAULT_ROW_HEIGHT = 50
const HEIGHT_CHANGE_THRESHOLD = 1 // px
const STABILIZE_DELAY = 100 // ms (หน่วงก่อน reset ถ้าไม่เปลี่ยนแล้ว)
const INDEX_STICKY_HEADER_ROW = 0

const isStickyHeaderRow = (index) => parseInt(index) === INDEX_STICKY_HEADER_ROW

export default function useCellMeasurer() {
    const listRef = useRef(null)
    const rowHeights = useRef({})
    const timeoutRef = useRef(null)

    const measure = (index, ref) => {
        if (!(ref instanceof HTMLElement)) return

        const newHeight = ref.getBoundingClientRect().height
        const prevHeight = rowHeights.current[index]
        // ถ้าความสูงเปลี่ยนน้อยกว่า threshold → ไม่ทำอะไร
        if (prevHeight && Math.abs(prevHeight - newHeight) < HEIGHT_CHANGE_THRESHOLD) return

        // อัปเดตค่าใหม่
        requestAnimationFrame(() => {
            rowHeights.current[index] = newHeight

            // debounce: ถ้าขนาดนิ่งแล้วค่อย reset layout
            if (timeoutRef.current) clearTimeout(timeoutRef.current)

            timeoutRef.current = setTimeout(() => {
                listRef.current?.resetAfterIndex(INDEX_STICKY_HEADER_ROW)
                timeoutRef.current = null
            }, STABILIZE_DELAY)
        })
    }

    const getItemSize = useCallback((index) => rowHeights.current[index] || DEFAULT_ROW_HEIGHT, [])

    const isMeasuring = useCallback((index) => !(index in rowHeights.current), [])

    const isMeasured = useCallback((index) => {
        const isHeightMeasured = typeof rowHeights.current[index] === "number"
        if (isStickyHeaderRow(index)) {
            return isHeightMeasured
        } else {
            const isUIApplied = timeoutRef.current === null
            return isHeightMeasured && isUIApplied
        }
    }, [])

    return {
        listRef,
        getItemSize,
        measure,
        isMeasured,
        isMeasuring
    }
}
